import angular from "angular";
import informationService from './information.service';

let informationModule = angular.module('information.service', [])
.service('Information', informationService)

.name;

export default informationModule;



// WEBPACK FOOTER //
// ./client/app/services/informationService/information.js